import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import PhotoCard from "./PhotoCard";
import PhotoForm from "./PhotoForm";
import Search from "./Search";

const PhotoContainer = ({ handleAddUserPhoto }) => {
    const [photos, setPhotos] = useState([])
    const [isLoaded, setIsLoaded] = useState(null)
    const [formShow, setFormShow] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [filterBy, setFilterBy] = useState("All")
    const user = useSelector((state) => state.user.loggedin)

    const handleToggleForm = () => {
      setFormShow(formShow => !formShow)
    }

    useEffect(() => {
      fetch("https://fotoset.herokuapp.com/photos")
      .then((r) => r.json())
      .then(photos => {
        setPhotos(photos)
        setIsLoaded(true)
      })
    }, [])

    const handleAddPhoto = (newPhoto) => {
      const updatePhotos = [...photos, newPhoto];
      setPhotos(updatePhotos)
    }

    const handleSearchText = (event) => {
      setSearchText(event.target.value)
    }

    const handleFilterClick = (event) => {
      setFilterBy(event.target.value)
    }

    const searchPhotos = photos.filter((photo) => photo.camera.toLowerCase().includes(searchText.toLowerCase()))

    const filterPhotos = searchPhotos.filter((p) => {
      if (filterBy === "All"){
        return p 
      } else {
        return p.category === filterBy
      }    
    })

    const photoList = filterPhotos.map((p) => {
        return(
           <PhotoCard 
            key={p.id}
            photo={p}
           /> 
        )
    })
    
    if (!isLoaded) return <h2 className="loading">Loading...</h2>;

    return(
  <div>
        <Search 
        searchText={searchText}
        handleSearchText={handleSearchText}
        handleFilterClick={handleFilterClick}
        filterBy={filterBy}
        />
        
          <div className="photo-container">
            {photoList}
          </div>
    
        {user ?  
        <>
          <div id="add-btn">
              {formShow ? 
              <button id="hide-form-btn" onClick={handleToggleForm}><i className="fas fa-minus-circle"></i> <i id="icon-color" className="fas fa-images"></i></button>
              :
              <button id="show-form-btn" onClick={handleToggleForm}><i className="fas fa-plus-circle"></i> <i id="icon-color" className="fas fa-images"></i></button>
              }
          </div>
            <PhotoForm
            formShow={formShow} 
            handleAddUserPhoto={handleAddUserPhoto} 
            handleAddPhoto={handleAddPhoto}
            />
        </>
          :null}
  </div>
    )
}

export default PhotoContainer;